import {VHChromeFix} from "../../Classes/VHChromeFix";

export class Hamburger {
    constructor()
    {
        this.hamburger      = document.querySelector('.hamburger');
        this.content_inner  = this.hamburger.querySelector('.hamburger__content-inner');
        this.header         = document.querySelector('.header');
        this.html           = document.querySelector('body');

        this.init_events();
        this.init_vhchromefix();
        this.init_offset();
    }

    init_offset()
    {
        let counter = 0;
        let interval = setInterval(() => {
            if(counter < 5){
                this.set_content_inner_offset();
                counter++;
            } else {
                clearInterval(interval);
            }
        }, 1000);
    }

    init_vhchromefix()
    {
        new VHChromeFix([
            {
                selector: '.hamburger__content-inner',
                vh: 100
            }
        ]);
    }

    init_events()
    {
        this.hamburger.addEventListener('click', () => {
            if(this.hamburger.classList.contains('hamburger--toggled')){
                this.hamburger.classList.remove('hamburger--toggled');
                this.header.classList.remove('header--hamburger-toggled');
                this.html.classList.remove('no-overflow');
            } else {
                this.hamburger.classList.add('hamburger--toggled');
                this.header.classList.add('header--hamburger-toggled');
                this.html.classList.add('no-overflow');
            }
        });

        this.content_inner.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        window.addEventListener('resize', () => {
            this.set_content_inner_offset();
        });
    }

    set_content_inner_offset()
    {
        const hamburger_offset  = this.hamburger.getBoundingClientRect();
        const hamburger_style   = window.getComputedStyle(this.hamburger);
        const hamburger_size    = {
            width: +hamburger_style.width.replace('px', ''),
            height: +hamburger_style.height.replace('px', '')
        }
        const offset = {
            top: Math.round(hamburger_offset.top + (hamburger_size.height / 2)),
            left: Math.round(hamburger_offset.left + (hamburger_size.width / 2)),
        }

        this.content_inner.style.transform = 'translate(-' + offset.left + 'px, -' + offset.top + 'px)';
    }
}
